function getCssVar(variable) {
  if (typeof window !== 'undefined' && window.getComputedStyle) {
    return getComputedStyle(document.documentElement).getPropertyValue(variable).trim() || variable;
  }
  return variable;
}

export const theme = () => {
  const showGrid = window.localStorage.getItem('showGrid') === 'true';

  const neutral400 = getCssVar('--neutral--400');
  const labelTextColor = getCssVar('--label-text-color');
  const inputBorder = getCssVar('--input-border');
  const widgetTooltip = getCssVar('--widget-tooltip');
  const tooltipTextColor = getCssVar('--tooltip-text-color');

  return {
    chart: {
      backgroundColor: 'transparent',
      style: {
        fontFamily: 'inherit',
        color: labelTextColor,
      },
    },
    xAxis: {
      labels: {
        style: {
          color: neutral400,
          fontSize: '11px',
        },
      },
      gridLineColor: showGrid ? inputBorder : 'transparent',
      title: {
        style: {
          color: neutral400,
        },
      },
    },
    yAxis: {
      labels: {
        style: {
          color: neutral400,
          fontSize: '11px',
        },
      },
      gridLineColor: showGrid ? inputBorder : 'transparent',
      title: {
        style: {
          color: neutral400,
        },
      },
    },
    legend: {
      itemStyle: {
        color: neutral400,
        fontSize: '10px',
      },
      itemHoverStyle: {
        color: labelTextColor,
      },
    },
    tooltip: {
      backgroundColor: widgetTooltip,
      style: {
        color: tooltipTextColor,
        fontSize: '12px',
      },
      borderColor: inputBorder,
      shadow: false,
    },
    colors: [
      getCssVar('--linechart-color-1'),
      getCssVar('--linechart-color-2'),
      getCssVar('--linechart-color-3'),
      getCssVar('--linechart-color-4'),
      getCssVar('--linechart-color-5'),
      getCssVar('--linechart-color-6'),
      getCssVar('--linechart-color-7'),
      getCssVar('--linechart-color-8'),
      getCssVar('--linechart-color-9'),
    ],
  };
};

export default theme;
